import { FC, useState } from 'react';
import Header from '../../../common/Header/Header';
import UnsavedChangesModal from '../../../common/UnsavedChangesModal/UnsavedChangesModal';
import { useEditMenus } from '../../../services/menu/menu.service';
import { ChangeSpecResponse } from '../../../services/menu/menu.types';
import { ChangeSpecsStep, CombinedSpec } from './ChangeSpecs.types';
import Confirmation from './Confirmation/Confirmation';
import ReviewChanges from './ReviewChanges/ReviewChanges';
import SelectMenus from './SelectMenus/SelectMenus';
import SelectSpec from './SelectSpec/SelectSpec';

const ChangeSpecs: FC = () => {
    const [step, setStep] = useState<ChangeSpecsStep>(0);
    const [selectedSpecs, setSelectedSpecs] = useState<CombinedSpec[]>([]);
    const [selectedMenus, setSelectedMenus] = useState<any[]>([]);
    const [selectedClass, setSelectedClass] = useState<number | undefined>(undefined);
    const [selectedBase, setSelectedBase] = useState<number | undefined>(undefined);
    const [selectedSize, setSelectedSize] = useState<number | undefined>(undefined);
    const [selectedProduct, setSelectedProduct] = useState<number | undefined>(undefined);
    const [results, setResults] = useState<ChangeSpecResponse[]>([]);

    const { mutateAsync } = useEditMenus();

    const renderStep = () => {
        switch (step) {
            default:
                return (
                    <SelectSpec
                        selectedSpecs={selectedSpecs}
                        setSelectedSpecs={setSelectedSpecs}
                        selectedClass={selectedClass}
                        setSelectedClass={setSelectedClass}
                        selectedBase={selectedBase}
                        setSelectedBase={setSelectedBase}
                        selectedSize={selectedSize}
                        setSelectedSize={setSelectedSize}
                        selectedProduct={selectedProduct}
                        setSelectedProduct={setSelectedProduct}
                        setStep={setStep}
                    />
                );
            case ChangeSpecsStep.SelectMenus:
                return (
                    <SelectMenus
                        selectedMenus={selectedMenus}
                        setSelectedMenus={setSelectedMenus}
                        setStep={setStep}
                        selectedSpecs={selectedSpecs}
                    />
                );
            case ChangeSpecsStep.ReviewChanges:
                return (
                    <ReviewChanges
                        selectedSpecs={selectedSpecs}
                        selectedMenus={selectedMenus}
                        mutateAsync={mutateAsync}
                        setResults={setResults}
                        setStep={setStep}
                    />
                );
            case ChangeSpecsStep.Confirmation:
                return (
                    <Confirmation
                        rowData={results}
                        setStep={setStep}
                    />
                );
        }
    };

    return (
        <>
            <Header
                breadcrumb={{ label: 'Back to All Menus', to: '/menus' }}
                title='Change Specs'
                stepTracker={
                    step !== ChangeSpecsStep.Confirmation
                        ? {
                            currentStep: step,
                            steps: [
                                { label: 'Select Spec', onClick: () => setStep(ChangeSpecsStep.SelectSpec) },
                                { label: 'Select Menu', onClick: () => setStep(ChangeSpecsStep.SelectMenus) },
                                { label: 'Review' },
                            ],
                        }
                        : undefined
                }
            />
            {renderStep()}
            <UnsavedChangesModal
                unsavedChangesExist={step === ChangeSpecsStep.SelectMenus || step === ChangeSpecsStep.ReviewChanges}/>
        </>
    );
};

export default ChangeSpecs;